import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { Response } from './Types';

class BancoController {
  public static async Listar(values: any): Promise<Response> {
    try {
      const response = await Api.post('api/bb/ListarBoleto', { liquidar: false, ...(values || {}) });

      const object = response?.data;
      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;

    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Detalhar(values: any): Promise<Response> {
    try {
      const response = await Api.post(`api/bb/DetalharBoleto`, values);

      const object = response?.data;

      return { StatusCode: response.status, Data: object };
    } catch (error: any) {
      // [SICOOB 30/09/2026] Mesmo tratamento do Cancelar, e pelo mesmo motivo: o 400
      // agora traz o porque da recusa (parcela sem boleto, conta sem integracao, a
      // resposta do proprio banco). Trocar esse corpo pelo ErrorDictionary generico
      // apagaria justamente a frase que explica o problema ao usuario.
      const apiData = error?.response?.data;
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado:
          apiData?.ErroDetalhado || apiData?.Erro ||
          (typeof apiData === 'string' ? apiData : undefined),
      };
    }
  }

  public static async Cancelar(values: any): Promise<Response> {
    try {
      const response = await Api.post(`api/bb/CancelarBoleto`, values);

      const object = response?.data;

      return { StatusCode: response.status, Data: object };
    } catch (error: any) {
      // [AJUSTE 11/08/2026] O motivo que a API manda no corpo (ErroDetalhado, com o texto
      // do proprio BB) tem de sobreviver. Antes o catch trocava o corpo pelo
      // ErrorDictionary genérico do status, e a razao da recusa era perdida aqui - depois
      // de ja ter sido descartada no backend.
      const apiData = error?.response?.data;
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado:
          apiData?.ErroDetalhado || apiData?.Erro ||
          (typeof apiData === 'string' ? apiData : undefined),
      };
    }
  }

  public static async Alterar(values: any): Promise<Response> {
    try {
      const response = await Api.post(`api/bb/AlterarBoleto`, values);

      const object = response?.data;

      return { StatusCode: response.status, Data: object };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
    }
  }

  // Diz se os boletos da venda podem ser reprocessados, e o motivo quando não podem.
  // O motivo vai para o tooltip do botão: botão cinza sem explicação já virou chamado
  // neste sistema.
  public static async PodeReprocessar(vndId: number): Promise<any> {
    try {
      const response = await Api.get(`api/bb/PodeReprocessarBoleto/${vndId}`);
      return response?.data ?? null;
    } catch (error: any) {
      return null;
    }
  }

  // Gera boletos novos para a venda. O servidor revalida a regra por conta própria -
  // o botão desabilitado é conveniência, não controle.
  public static async Reprocessar(vndId: number): Promise<Response> {
    try {
      const response = await Api.post(`api/bb/ReprocessarBoleto/${vndId}`);
      return { StatusCode: response.status, Data: response?.data };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        // 400 traz o motivo da recusa vindo da regra; os demais caem no dicionário.
        Data: error?.response?.data?.message
          ?? ErrorDictionary(error?.response?.status),
      };
    }
  }

  public static async Gerar(pId: number): Promise<Response> {
    try {
      const response = await Api.post('api/bb/GerarBoleto', { pId });

      const object = response?.data;
      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;

    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default BancoController;
